import { ENDPOINTS } from 'utils/api/callApi'

export enum SHIPMENT_ACTION_TYPES {
  FETCH_SHIPMENT_REQUEST = 'FETCH_SHIPMENT_REQUEST',
  FETCH_SHIPMENT_SUCCESS = 'FETCH_SHIPMENT_SUCCESS',
  FETCH_SHIPMENT_FAILURE = 'FETCH_SHIPMENT_FAILURE',
}

export enum AUCTION_SHIPMENT_ACTION_TYPES {
  FETCH_AUCTION_SHIPMENT_REQUEST = 'FETCH_AUCTION_SHIPMENT_REQUEST',
  FETCH_AUCTION_SHIPMENT_SUCCESS = 'FETCH_AUCTION_SHIPMENT_SUCCESS',
  FETCH_AUCTION_SHIPMENT_FAILURE = 'FETCH_AUCTION_SHIPMENT_FAILURE',
}

export const getShipment = (id: string) => ({
  payload: {
    callApi: true,
    requestData: {
      id,
      endpoint: ENDPOINTS.shipments,
    },
    actionTypes: Object.keys(SHIPMENT_ACTION_TYPES),
  },
})

export const getAuctionShipment = (id: string) => ({
  payload: {
    callApi: true,
    requestData: {
      id,
      endpoint: ENDPOINTS.auctionShipments,
    },
    actionTypes: Object.keys(AUCTION_SHIPMENT_ACTION_TYPES),
  },
})
